"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNewIdentifier = exports.retrieveIdentifier = void 0;
const domain_id_1 = require("@streem/domain-id");
const DEVICE_ID_KEY_EV2 = 'STREEM_WEB_SDK_DEVICE_ID_EV2';
const DEVICE_ID_KEY_EMBED = 'STREEM_WEB_SDK_DEVICE_ID_EMBED';
const DEVICE_ID_KEY_EMBED_SALESFORCE = 'STREEM_WEB_SDK_DEVICE_ID_EMBED_SALESFORCE';
const EV2 = 'ev2';
const EMBED = 'embed';
const EMBED_SALESFORCE = 'embedSalesforce';
function retrieveIdentifier() {
    const type = sessionStorage.getItem('appType');
    const appType = type != null ? type : EV2;
    let identifier = null;
    if (appType == EV2) {
        identifier = localStorage.getItem(DEVICE_ID_KEY_EV2);
    }
    if (appType == EMBED) {
        identifier = localStorage.getItem(DEVICE_ID_KEY_EMBED);
    }
    if (appType == EMBED_SALESFORCE) {
        identifier = localStorage.getItem(DEVICE_ID_KEY_EMBED_SALESFORCE);
    }
    if (!identifier) {
        return generateNewIdentifier(appType);
    }
    return new domain_id_1.DeviceId(identifier);
}
exports.retrieveIdentifier = retrieveIdentifier;
function generateNewIdentifier(appType) {
    const identifier = new domain_id_1.DeviceId();
    saveIdentifier(identifier, appType);
    return identifier;
}
exports.generateNewIdentifier = generateNewIdentifier;
function saveIdentifier(identifier, appType) {
    if (appType == EV2) {
        localStorage.setItem(DEVICE_ID_KEY_EV2, identifier.toString());
    }
    if (appType == EMBED) {
        localStorage.setItem(DEVICE_ID_KEY_EMBED, identifier.toString());
    }
    if (appType == EMBED_SALESFORCE) {
        localStorage.setItem(DEVICE_ID_KEY_EMBED_SALESFORCE, identifier.toString());
    }
}
//# sourceMappingURL=storage.js.map